export function isLocalAbsolutePath(path: string): boolean {
  if (/^[a-zA-Z]:[\\/]/.test(path)) {
    return true
  }

  if (path.startsWith('/') && !path.startsWith('//')) {
    return /^\/(home|usr|var|tmp|mnt|opt|root|etc|data|models?)\//i.test(path)
  }

  return false
}

export function toLocalFileProxy(path: string): string {
  return `${window.location.origin}/local-file/${encodeURIComponent(path)}`
}

export function resolveGaussianSplatInputPath(rawPath: string): string {
  if (rawPath.startsWith('http://') || rawPath.startsWith('https://')) {
    return rawPath
  }

  if (isLocalAbsolutePath(rawPath)) {
    return toLocalFileProxy(rawPath)
  }

  const hasExtension = /\.[^\\/]+$/.test(rawPath)
  if (hasExtension) {
    return `${window.location.origin}/${rawPath.replace(/^\/+/, '')}`
  }

  const basePath = rawPath.endsWith('/') ? rawPath : `${rawPath}/`
  return `${window.location.origin}/models/${basePath}lod-meta.json`
}

export function resolvePointCloudInputPath(rawPath: string): string {
  if (rawPath.startsWith('http://') || rawPath.startsWith('https://')) {
    return rawPath
  }

  if (isLocalAbsolutePath(rawPath)) {
    return toLocalFileProxy(rawPath)
  }

  if (/\.[^\\/]+$/.test(rawPath)) {
    return rawPath
  }

  const basePath = rawPath.endsWith('/') ? rawPath : `${rawPath}/`
  return `/models/${basePath}metadata.json`
}

export function extractLocalAbsolutePath(file: File, inputValue?: string): string | null {
  const maybeFile = file as File & {
    path?: string
    filepath?: string
  }

  if (typeof maybeFile.path === 'string' && maybeFile.path.trim()) {
    return maybeFile.path
  }

  if (typeof maybeFile.filepath === 'string' && maybeFile.filepath.trim()) {
    return maybeFile.filepath
  }

  if (typeof inputValue === 'string') {
    const trimmedValue = inputValue.trim()
    if (trimmedValue && !/fakepath/i.test(trimmedValue) && isLocalAbsolutePath(trimmedValue)) {
      return trimmedValue
    }
  }

  return null
}

export function resolveSpatialWorldInputPath(rawPath: string): string {
  if (!rawPath.trim()) {
    return rawPath
  }

  if (rawPath.startsWith('http://') || rawPath.startsWith('https://')) {
    return rawPath
  }

  if (rawPath.startsWith(window.location.origin)) {
    return rawPath
  }

  if (isLocalAbsolutePath(rawPath)) {
    return toLocalFileProxy(rawPath)
  }

  if (/^[./]/.test(rawPath) || /\.[^\\/]+$/.test(rawPath)) {
    return `${window.location.origin}/${rawPath.replace(/^\/+/, '')}`
  }

  return rawPath
}
